import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { Mail } from 'lucide-react';
import { authService } from '@/services/authService';

export default function ForgotPassword() {
  const { register, handleSubmit, formState: { isSubmitting }, reset } = useForm();
  const onSubmit = async (data) => {
    try {
      const res = await authService.forgotPassword(data);
      toast.success(res.message);
      // res.resetUrl is exposed by the API in non-production for local testing only.
      if (res.resetUrl && import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.log('[dev] Reset URL:', res.resetUrl);
      }
      reset();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not send reset email');
    }
  };
  return (
    <div className="card p-8">
      <h2 className="text-2xl font-bold">Forgot password</h2>
      <p className="text-sm text-slate-500 mt-1">Enter your email and we'll send you a reset link.</p>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 mt-6">
        <div>
          <label className="label">Email</label>
          <div className="relative">
            <Mail size={16} className="absolute left-3 top-3 text-slate-400" />
            <input
              type="email"
              className="input pl-9"
              placeholder="you@company.com"
              {...register('email', { required: true })}
            />
          </div>
        </div>
        <button type="submit" disabled={isSubmitting} className="btn-primary w-full">
          {isSubmitting ? 'Sending...' : 'Send reset link'}
        </button>
      </form>
      <div className="text-sm text-slate-500 mt-4 text-center">
        Remember it? <Link to="/login" className="text-brand-600 hover:underline">Sign in</Link>
      </div>
    </div>
  );
}
